//import Vue from 'vue'

/* 公用函式 */
/** 判斷目前系統平台 */
export function getMobileOperatingSystem() {
    let userAgent = window.navigator.userAgent,
        platform = window.navigator.platform,
        macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
        windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
        iosPlatforms = ['iPhone', 'iPad', 'iPod'],
        os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
        os = 'Mac OS';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
        os = 'iOS';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
        os = 'Windows';
    } else if (/Android/.test(userAgent)) {
        os = 'Android';
    } else if (!os && /Linux/.test(platform)) {
        os = 'Linux';
    } else {
        os = 'unknown';
    }

    return os;

}

/** 取得副檔名 */
export function getFileExtension(filename) {
    return (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
}

/** 判斷物件是否 非undefined也非null，都符合的話回傳true */
export function notNull(obj) {
    return (obj !== undefined && obj !== null);
}

/** test */
export function testEncrypt(account) {
    let decodeAry = [
        ['18', '1'],
        ['9F', '2'],
        ['75', '3'],
        ['BE', '4'],
        ['C1', '5'],
        ['19', '6'],
        ['D7', '7'],
        ['E1', '8'],
        ['43', '9'],
        ['3A', '0']];

    let result = '';
    if (account !== undefined && account !== null && account !== '') {
        for (let i = 0; i < account.length; i++) {
            for (let j = 0; j < decodeAry.length; j++) {
                if (account[i] === decodeAry[j][1]) {
                    result += ('/!' + decodeAry[j][0]);
                    // console.log('decode add :' + result);
                    break;
                }
            }
        }
    }

    console.log('encode :' + result);
}

export function testDecrypto(account) {
    let decodeAry = [
        ['18', '1'],
        ['9F', '2'],
        ['75', '3'],
        ['BE', '4'],
        ['C1', '5'],
        ['19', '6'],
        ['D7', '7'],
        ['E1', '8'],
        ['43', '9'],
        ['3A', '0']];

    let accountAry = account.split('/!');
    // console.log('decode ary :' + accountAry);
    let result = '';
    for (let i = 0; i < accountAry.length; i++) {
        for (let j = 0; j < decodeAry.length; j++) {
            if (accountAry[i] === decodeAry[j][0]) {
                result += decodeAry[j][1];
                // console.log('decode add :' + result);
                break;
            }
        }
    }

    console.log('decode :' + result);
}
